;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { Button, ButtonIcon } from '@qogita/ui/v2/button'
import { Checkbox } from '@qogita/ui/v2/checkbox'
import { Icon } from '@qogita/ui/v2/icon'
import { Input, InputIcon } from '@qogita/ui/v2/input'
import { Popover, PopoverContent, PopoverTrigger } from '@qogita/ui/v2/popover'
import { Separator } from '@qogita/ui/v2/separator'
import { useQuery } from '@tanstack/react-query'
import clsx from 'clsx'
import React, { useState } from 'react'
import { getOfferQueries } from 'src/deprecated/api/offer-queries'
import { useInventoryQueryParams } from 'src/deprecated/hooks/utils/useInventoryQueryParams'
import { trackInventoryFiltered } from 'src/deprecated/utils/report/tracking'

const BrandsContent = () => {
  const canaryClient = useCanaryClient()
  const offerQueries = getOfferQueries(canaryClient)

  const { toggleBrandsFilter, brandsFilter, clearBrandsFilter } =
    useInventoryQueryParams()

  const { data: sellerBrands } = useQuery(offerQueries.sellerBrands())

  const [search, setSearch] = useState('')

  const brandDropdownOptions = search
    ? sellerBrands
        ?.filter((brand) =>
          brand.name.toLowerCase().includes(search.toLowerCase()),
        )
        .slice(0, 30)
    : sellerBrands?.slice(0, 100)

  return (
    <>
      <div className="flex w-[272px] flex-col gap-1 p-1">
        <div className="flex flex-col p-3">
          <div className="relative flex">
            <Input
              type="text"
              placeholder="Search"
              // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
              className="font-outfit w-full rounded-full p-2 px-3 pr-9"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
            {search ? (
              <Button
                size="small"
                variant="text"
                onClick={() => setSearch('')}
                // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
                className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400"
              >
                <ButtonIcon name="heroicons/solid/x-mark" />
              </Button>
            ) : (
              <div className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400">
                <InputIcon name="heroicons/solid/magnifying-glass" />
              </div>
            )}
          </div>
        </div>
        <div className="max-h-60 overflow-y-scroll">
          {brandDropdownOptions?.map((brand) => (
            <div
              key={brand.qid}
              className="block rounded-sm hover:bg-gray-100 active:bg-gray-200"
            >
              <label className="flex w-full cursor-pointer items-center gap-2 p-2 text-base">
                <Checkbox
                  checked={brandsFilter.includes(brand.name)}
                  onCheckedChange={() => {
                    if (!brandsFilter.includes(brand.name)) {
                      trackInventoryFiltered({
                        type: 'brand',
                        brand: brand.name,
                        source: 'brandsFilter',
                      })
                    }
                    toggleBrandsFilter(brand.name)
                  }}
                />
                <span
                  translate="no"
                  className="font-outfit font-light text-gray-700"
                >
                  {brand.name}
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>
      <Separator orientation="horizontal" />
      <div className="px-3 py-2">
        <Button
          variant="text"
          onClick={() => {
            clearBrandsFilter()
            setSearch('')
          }}
          disabled={!brandsFilter.length && !search}
        >
          Clear
        </Button>
      </div>
    </>
  )
}

export const InventoryBrandsFilter = () => {
  const canaryClient = useCanaryClient()
  const offerQueries = getOfferQueries(canaryClient)

  const [open, setOpen] = useState(false)
  useQuery(offerQueries.sellerBrands()) // fetch the brands before the dropdown is opened

  return (
    <Popover open={open} onOpenChange={setOpen}>
      {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
      <PopoverTrigger className="flex items-center gap-2 rounded-sm border border-gray-300 bg-white px-4 py-2 font-light whitespace-nowrap hover:bg-gray-100 focus-visible:bg-gray-100 active:bg-gray-100">
        <span className="font-outfit text-sm text-gray-500">
          Filter by brand
        </span>
        <Icon
          name="heroicons/solid/chevron-down"
          className={clsx(
            // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
            'size-4 transform text-gray-400 transition-transform duration-200 ease-in-out',
            {
              'rotate-180': open,
            },
          )}
        />
      </PopoverTrigger>
      <PopoverContent align="start" className="z-10">
        {open ? <BrandsContent /> : null}
      </PopoverContent>
    </Popover>
  )
}
